module.exports = __webpack_public_path__ + "media/images/flags/gu-459831ea94ce2f15eede065e961764df.svg";